import './App.css';
import Navigation from './components/Navigation/Navigation'
import AppRoutes from './routes/AppRoutes';


function App() {
  return (
    <>
      <Navigation />
      <AppRoutes />
    </>
  )
}

export default App
